module.exports = "<sui-select \n  class=\"selection\"\n  placeholder=\"Membre\"\n  [ngModel]=\"active\"\n  (ngModelChange)=\"onChange($event)\"\n  [options]=\"options\"\n  labelField=\"name\"\n  valueField=\"user\"\n  [isSearchable]=\"true\"\n  #searchSelect>\n    <sui-select-option \n      *ngFor=\"let o of searchSelect.filteredOptions\" \n      [value]=\"o\">\n    </sui-select-option>\n</sui-select>";


//////////////////
// WEBPACK FOOTER
// ./app/components/select-user/select-user.component.html
// module id = 1025
// module chunks = 0